// header-documento-final-proposta.component.ts
import {Component, Input} from '@angular/core';
import {TipoProduto_E_OperadoraEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-header-documento-final-proposta',
  templateUrl: './header-documento-final-proposta.component.html',
  styleUrls: ['./header-documento-final-proposta.component.scss'],
})
export class HeaderDocumentoFinalPropostaComponent {
  @Input() entidadeProposta: string = '';
  @Input() razaoSocialEntidade: string = '';
  @Input() codigoProposta: string = '';
  @Input() vigenciaProposta: string = '';
  @Input() operadoraVM: any;
  @Input() dadosOperadoraCabecalho: any;

  readonly TIPO_UDEMO = TipoProduto_E_OperadoraEnum.UDEMO_SAUDE;
  readonly TIPO_FESP = TipoProduto_E_OperadoraEnum.UNIMEDFESP_SAUDE;
}
